'use strict';

var SaveAndInitializeModalDirective = function SaveAndInitializeModalDirective() {
  return {
    restrict: 'E',
    replace: true,
    template: require('../templates/save-and-initialize-modal.html'),
    scope: true,
    controller: 'SaveAndInitializeModalController'
  };
};
SaveAndInitializeModalDirective.$inject = [];
module.exports = SaveAndInitializeModalDirective;